function Reports({ children }: any) {
  return <>{children}</>;
}

export default Reports;
